/** @jsx React.DOM */
'use strict';

var React = require('react'),
    ItemTypes = require('./ItemTypes'),
    $__0=    require('react-dnd'),DragDropMixin=$__0.DragDropMixin,
    $__1=    React,PropTypes=$__1.PropTypes;

var Dustbin = React.createClass({displayName: 'Dustbin',
  mixins: [DragDropMixin],

  propTypes: {
    accepts: PropTypes.array.isRequired
  },

  getInitialState:function() {
    return {
      lastDroppedItem: null
    };
  },

  configureDragDrop:function(registerType) {
    var dropTarget = {
      acceptDrop:function(item) {
        this.setState({
          lastDroppedItem: item
        });
      }
    };

    this.props.accepts.forEach(function(itemType)  {
      registerType(itemType, {
        dropTarget: dropTarget
      });
    });
  },

  render:function() {
    var types = this.props.accepts,
        dropStates = types.map(this.getDropState),
        backgroundColor = '#222';

    if (dropStates.some(function(s)  {return s.isHovering;})) {
      backgroundColor = 'darkgreen';
    } else if (dropStates.some(function(s)  {return s.isDragging;})) {
      backgroundColor = 'darkkhaki';
    }

    return (
      React.createElement("div", React.__spread({},  this.dropTargetFor.apply(this, types), 
           {style: {
             height: '12rem',
             width: '12rem',
             color: 'white',
             backgroundColor: backgroundColor,
             padding: '2rem',
             margin: '0.5rem',
             textAlign: 'center',
             float: 'left'
           }}), 

        dropStates.some(function(s)  {return s.isHovering;}) ?
          'Release to drop' :
          'This dustbin accepts: ' + this.props.accepts.join(', '), 
        

        this.state.lastDroppedItem &&
          React.createElement("p", null, "Last dropped: ", JSON.stringify(this.state.lastDroppedItem))
        
      )
    );
  }
});

module.exports = Dustbin;


/*****************
 ** WEBPACK FOOTER
 ** ./_dustbin-interesting/Dustbin.js
 ** module id = 140
 ** module chunks = 0
 **/